"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORGANISATION_ID = void 0;
var ORGANISATION_ID = {
  SHOOTSTA: 'f4e7f2c7-7911-4ca9-84f0-4b3ca37249bd',
  ELEVATE_GUEST: '6b660c58-9dd0-11eb-bd36-9f9924e821e8'
};
exports.ORGANISATION_ID = ORGANISATION_ID;